import EventList from "./EventsList";
import { useGetPublishedPosts } from "./api/published-api";
// import EventListSuspense from "./suspense";
import { cn } from "@/lib/utils"
import { Button } from "@/shared/ui/button.tsx"
import { Calendar } from "@/shared/ui/calendar.tsx"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/popover.tsx"
import { format, subDays } from "date-fns"
import { CalendarIcon } from "lucide-react"
import { DateRange } from "react-day-picker"
import { useState } from "react";



const PublishedEventTab = () => {

    const [date, setDate] = useState<DateRange | undefined>({
    from: subDays( new Date(), 7 ),
    to: new Date(),
  })


  const { publishedPosts } = useGetPublishedPosts(
    date?.from ? format(date.from, "yyyy-MM-dd") : format(subDays(new Date(), 20), "yyyy-MM-dd"), 
    date?.to ? format(date.to, "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd")
  )

  return (
    <section className="w-full ">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2 py-2">
          <Popover>
            <PopoverTrigger asChild>
              <Button
                id="date"
                variant={"outline"}
                className={cn(
                  "w-[300px] justify-start text-left font-normal",
                  !date && "text-muted-foreground"
                )}
              >
                <CalendarIcon />
                {date?.from ? (
                  date.to ? (
                    <>
                      {format(date.from, "LLL dd, y")} -{" "}
                      {format(date.to, "LLL dd, y")}
                    </>
                  ) : (
                    format(date.from, "LLL dd, y")
                  )
                ) : (
                  <span>Pick a date</span>
                )}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                initialFocus
                mode="range"
                defaultMonth={date?.from}
                selected={date}
                onSelect={setDate}
                numberOfMonths={2}
              />
            </PopoverContent>
          </Popover>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        {/* !publishedPosts && <EventListSuspense /> */}
        {publishedPosts && publishedPosts.data.map((socialEvent) => (
          <EventList socialData={socialEvent} key={socialEvent.event_id} event_status="Pending" name={socialEvent.event} />
        ))}
        {publishedPosts && publishedPosts.data.length === 0 && (
          <p>No posts matching filter</p>
        )}
      </div>
    </section>
  )
}

export default PublishedEventTab;
